import React from 'react'

import headerStyles from '../styles/headerblog.module.scss'
import '../styles/button.scss'
import Nav from './navBlog'


const Header = () => {

    return(

        
        <header className={headerStyles.header}> 
            <Nav />
        </header>
    )
}

export default Header